<template>
  <div v-if="graphConfig.isMultiMetric">
    <div>
      <MultiLineChart
        :data="chartData"
        :legendHeaders="graphConfig.headers"
        :showLegend="true"
        :intervalTime="intervalTime"
        :chartId="getRandomUniqueId"
        :graphIndex="index"
        :title="graphConfig.title"
        :Graphlabels="graphConfig.graphTitles"
        :formula="graphConfig.formula"
        :loading="loading"
        @openModal="openGraphModal"
        :show-more-options="showMoreOptions"
        :moreOptionsData="moreOptionsData"
        @handle-more-options-click="
          () => $emit('handle-more-options-click', graphConfig.title)
        "
      />
    </div>
    <div>
      <MultiChartModal
        :showGraphModal="this.showGraphModal"
        :data="chartData"
        :infoSpanColIndex="1"
        :highLightColValue="0"
        :legendHeaders="graphConfig.headers"
        :showLegend="true"
        :intervalTime="intervalTime"
        :chartId="getRandomUniqueId"
        :graphIndex="index"
        :title="graphConfig.title"
        :Graphlabels="graphConfig.graphTitles"
        :formula="graphConfig.formula"
        :loading="loading"
        @openModal="openGraphModal"
        @onHide="showGraphModal = false"
        @closeGraphModal="showGraphModal = false"
      />
    </div>
  </div>

  <div v-else class="graph-builder-wrapper">
    <GraphBuilder
      :show-more-options="showMoreOptions"
      :moreOptionsData="moreOptionsData"
      :chartConfig="graphConfig"
      :index="index"
      :layoutIndex="0"
    />
  </div>
</template>

<script>
import MultiLineChart from '@/components/charts/multi-chart.vue';
import MultiChartModal from '@/components/charts/multi-chart-modal';
import { mapActions, mapGetters, mapState } from 'vuex';
import { getRandomUniqueId } from '@/utils/helper-function';
import GraphBuilder from '@/components/Common/GraphBuilder.vue';

export default {
  components: {
    MultiLineChart,
    MultiChartModal,
    GraphBuilder,
  },
  name: 'AwsMetricGraph',
  props: {
    moreOptionsData: { type: Array, default: () => [] },
    graphConfig: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    showMoreOptions: {
      type: Boolean,
      required: false,
    },
    sliceGraphLabels: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['handle-more-options-click'],
  data() {
    return {
      chartData: [],
      loading: false,
      showGraphModal: false,
    };
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime', 'intervalTime']),
    ...mapGetters('cloudState/detail', ['getCurrentServiceInstance']),
    ...mapState('cloudState/detail', ['currentServiceInstance']),
    getRandomUniqueId,
  },
  methods: {
    ...mapActions('cloudState/detail', ['getGraphData']),
    openGraphModal() {
      this.showGraphModal = true;
    },
    async fetchGraphData() {
      if (!this.graphConfig.isMultiMetric) return;
      try {
        this.loading = true; // Start loading
        const params = {
          duration: this.getDurationTime,
          index: this.index,
        };
        const response = await this.getGraphData(params);
        if (!this.sliceGraphLabels) {
          const labels = this.label.split(', ').slice(0, 5);
          this.chartData = response.slice(0, 5).map((item, idx) => ({
            ...item.readMetricsValues,
            label: labels[idx] || '',
          }));
        } else {
          const labels = this.label.split(', ');
          this.chartData = response.map((item, idx) => ({
            ...item.readMetricsValues,
            label: labels[idx] || '',
          }));
        }
      } catch (error) {
        console.error('Error fetching graph data:', error);
        // Handle error scenario as needed
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    if (this.index >= 0 && Object.keys(this.graphConfig).length > 0) {
      this.fetchGraphData();
    }
  },
  watch: {
    getDurationTime() {
      this.fetchGraphData();
    },
    currentServiceInstance() {
      this.fetchGraphData();
    },
    label() {
      this.fetchGraphData();
    },
  },
};
</script>
